// extracted by mini-css-extract-plugin
export default {"title":"b382f022d5","inner_title":"ba9f32aafb","charge_btn":"a2831c8d58"};